import React, { createContext, useContext, useState, useEffect } from "react";
import translations from "@/lib/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [locale, setLocaleState] = useState("id");

  useEffect(() => {
    localStorage.setItem("nauranuma_locale", "id");
  }, []);

  const setLocale = () => {
    setLocaleState("id");
    localStorage.setItem("nauranuma_locale", "id");
  };

  const toggleLanguage = () => {
    setLocale();
  };

  // Helper function to get translation
  const t = (path) => {
    const keys = path.split(".");
    let result = translations[locale];
    for (const key of keys) {
      if (result[key]) {
        result = result[key];
      } else {
        return path; // Fallback to key itself if not found
      }
    }
    return result;
  };

  return (
    <LanguageContext.Provider value={{ locale, setLocale, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
